// extracted by mini-css-extract-plugin
module.exports = {"top":"Layout_top__344g2","topBottomGutter":"Layout_topBottomGutter__2XD93"};